import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutService } from '../../services/layout.service';
import { TickerItem } from '../../models/ticker-item.model';

@Component({
  selector: 'app-dashboard-ticker',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dashboard-ticker.component.html',
  styleUrls: ['./dashboard-ticker.component.css'],
})
export class DashboardTickerComponent {
  @Input() items: TickerItem[] = [];
  @Input() loading = false;

  readonly layoutService = inject(LayoutService);

  get containerClasses(): string {
    const base =
      'fixed bottom-0 right-0 z-40 hidden h-11 items-center overflow-hidden border-t border-card-border-border bg-sidebar-panel transition-all duration-200 md:flex';
    const offset = this.layoutService.isSidebarCollapsed() ? 'sidebar-collapsed-left' : 'sidebar-expanded-left';
    return `${base} ${offset}`;
  }
}
